module.exports = __webpack_public_path__ + "img/bitcoin.9eb53914.png";